import React from 'react';

const TopInfo = ({appointmentDetails}) => {
    return (
        <div className="w-full shadow-lg px-4 py-2">
            <div className="grid grid-rows-1 grid-cols-2">
                <div className="text-xs">
                    <p className='text-carching-pink'>{appointmentDetails.name}</p>
                    <p>{appointmentDetails.car_brand_model}</p>
                    <p>{appointmentDetails.campaign}</p>
                </div>
                <div className="text-xs text-right">
                    <p className='text-carching-pink'>{appointmentDetails.booking_id}</p>
                    <p>{appointmentDetails.installer_workshop}</p>
                    <p>{appointmentDetails.appointment_datetime}</p>
                </div>
            </div>
        </div>
    );
};

export default TopInfo;